import { getPaginatedOrderHistory, getPaginatedTrades } from '$lib/data/userHoldings';
import type { MarketIdentifiers } from '$lib/types/market';
import type { Order } from '$lib/types/order';
import { chain } from '$lib/wallet/store';
import { waitForTransaction, type SendTransactionResult } from '@wagmi/core';
import { get } from 'svelte/store';
import { unsubmittedOrders } from '../store';
import { positionsRaw } from '$store/positions';
import { ordersRaw } from '$store/orders';

export async function refreshUserHoldings() {
	positionsRaw.apiCall({});
	ordersRaw.apiCall({});
	getPaginatedTrades();
	getPaginatedOrderHistory();
}

function getBackendCompatibleAsset(asset: string) {
	if (['ETH', 'BTC'].includes(asset)) {
		asset = 's' + asset;
	}
	return asset;
}

function getOrderObject(
	marketIdentifier: MarketIdentifiers,
	marketAsset: string,
	orderAmount: string,
	scw: string,
	res: any
) {
	let ord = {
		asset: marketAsset,
		marketIdentifier: marketIdentifier,
		marketAddress: '',
		orderType: '',
		size: orderAmount,
		orderId: '',
		orderIdUi: `${marketAsset}-${scw.toLowerCase()}-${res.blockNumber}`,
		status: 'Pending',
		timestamp: new Date().getTime().toString(),
		expiry: '',
		keeper: '',
		requestPrice: '',
		limitPrice: '',
		triggerPrice: '',
		triggerType: '',
		priceImpactDelta: '',
		requestId: '',
		retries: 0,
		lastErrorMessage: '',
		totalFee: '',
		keeperDeposit: '',
		commitDeposit: '',
		tradeFee: '',
		currentPositionSize: ''
	};
	return ord;
}

export async function addUnsubmittedOrder(
	marketIdentifier: MarketIdentifiers,
	marketAsset: string,
	orderAmount: string,
	scw: string,
	tx: SendTransactionResult
) {
	marketAsset = getBackendCompatibleAsset(marketAsset);
	const res = await waitForTransaction({
		chainId: get(chain)?.id,
		hash: tx.hash
	});
	let orderToAdd: Order = getOrderObject(marketIdentifier, marketAsset, orderAmount, scw, res);
	let orderId = orderToAdd.orderIdUi;
	let orders = get(unsubmittedOrders);
	orders[orderId] = orderToAdd;
	unsubmittedOrders.set(orders);
}
